import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=858a926e&scoped=true&"
import script from "./cabinet.vue?vue&type=script&lang=js&"
export * from "./cabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858a926e",
  null
  
)

export default component.exports